// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1HRak","title":"Images45_title__2EEtg","images":"Images45_images__10nDQ"};